import React, { Component } from 'react';

export default class Seasonal_Recipes extends Component {
  constructor() {
    super();
    this.state = {
      recipes: [],
      banner_img: [],
      base_url: global.BaseUrl,
      assets_url:global.AssetsUrl,
      expandedRecipe: null, // Track which recipe is expanded
    };
  }

  componentDidMount() {
    fetch(`${this.state.base_url}/getSeasonalRecipes`)
      .then((resp) => resp.json())
      .then((result) => {
        this.setState({ recipes: result });
      });

    fetch(`${this.state.base_url}/getBannerById/6`)
      .then((resp) => resp.json())
      .then((result) => {
        this.setState({ banner_img: result.banner_images });
      });
  }

  toggleExpand = (recipeId) => {
    this.setState((prevState) => ({
      expandedRecipe: prevState.expandedRecipe === recipeId ? null : recipeId,
    }));
  };

  render() {
    const { recipes, expandedRecipe } = this.state;
    const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });

    return (
      <>
        
        <div className="container " style={{ marginTop: '70px' }}> 
            <div className="row">
              {recipes.map((recipe) => (
                <div key={recipe.recipe_image} className="col-md-6 tablet col-sm-12 col-xs-12">
                  <div data-wow-delay="0s" className="blog-item swin-transition item wow fadeInUpShort" style={{marginBottom: 20, visibility: 'visible', animationDelay: '0s', animationName: 'fadeInUpShort'}}>
                    <div className="card mb-4 shadow-sm "> 
                      <img src={`${this.state.assets_url}/uploads/${recipe.recipe_image}`} alt="Magma"  className="img img-responsive banner_img" />
                      <div style={{  marginBottom: 20, visibility: "visible", animationDelay: "0s", animationName: "fadeInUpShort",  }}>
                        <div className="blog-content">
                          <div className="blog-date"  onClick={() => this.toggleExpand(recipe.recipe_image)} style={{ cursor: "pointer" }} >
                            {expandedRecipe === recipe.recipe_image ? "View Less" : "View More"}
                          </div> 

                            <div className="card-title fw-semibold pt-2">{recipe.recipe_title}</div>
                            <div className="product-info">
                              <table className="my_table">
                                <thead>
                                  <tr>
                                    <th className="product-name"> <span>Preparation time : </span> <span className="text">{recipe.recipe_preptime}</span> </th>
                                    <th className="product-name"> <span>Total time : </span> <span className="text">{recipe.recipe_totaltime}</span> </th>
                                    <th className="product-name"> <span>Serves : </span> <span className="text">{recipe.recipe_serves}</span> </th>
                                  </tr>
                                </thead>
                              </table>
                            </div>
                            {expandedRecipe === recipe.recipe_image && (
                              <div className="expanded-content">
                                <div className="product-info para">
                                  <div className="card-title fw-semibold pt-2">{recipe.description_title}</div>
                                  <div className='text-secondary'>{renderHTML(recipe.description)}</div>
                                </div>
                                <div className="product-info para">
                                  <div className="card-title fw-semibold pt-2">Ingredients</div>
                                  <div className="para text-secondary">{renderHTML(recipe.recipe_ingredients)}</div>
                                </div>
                                <div className="product-info para">
                                  <div className="card-title fw-semibold pt-2">Directions</div>
                                  <div className='text-secondary'>{renderHTML(recipe.recipe_method)}</div>
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div> 
        </div>
      </>
    );
  }
}
